import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AppsIcon from '@material-ui/icons/Apps';
import StorageIcon from '@material-ui/icons/Storage';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import CheckIcon from '@material-ui/icons/Check';
import EcoIcon from '@material-ui/icons/Eco';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import GroupIcon from '@material-ui/icons/Group';
import MailIcon from '@material-ui/icons/Mail';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import PersonIcon from '@material-ui/icons/Person';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import PaymentIcon from '@material-ui/icons/Payment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faJar } from '@fortawesome/free-solid-svg-icons';
import { faCow } from '@fortawesome/free-solid-svg-icons';
import { OPERATING } from '../config';
import React from 'react';
import { Redirect } from 'react-router';

const Datos = React.lazy(() => import('../screens/datos/Datos'));
const Activos = React.lazy(() => import('../screens/certificados-activos/Activos'));
const Servicios = React.lazy(() => import('../screens/servicios/Servicios'));
const Visitas = React.lazy(() => import('../screens/visitas/Visitas'));
//const Facturacion = React.lazy(() => import('../screens/facturacion/Facturacion'));
//const Abonos = React.lazy(() => import('../screens/abonos/Abonos'));
const Aplicaciones = React.lazy(() => import('../screens/aplicaciones/Aplicaciones'));
const Comunicaciones = React.lazy(() => import('../screens/comunicaciones/Comunicaciones'));
const Contacta = React.lazy(() => import('../screens/contacta/Contacta'));
//const Usuarios = React.lazy(() => import('../screens/usuarios/Usuarios'));
//const Delegaciones = React.lazy(() => import('../screens/delegaciones/Delegaciones'));
const ExplotacionParcelas = React.lazy(() => import('../components/Explotacion/Parcelas'));
const ExplotacionGanado = React.lazy(() => import('../components/Explotacion/Ganado'));
const ExplotacionProductos = React.lazy(() => import('../components/Explotacion/Productos'));


const size = "large";
const sizeSubMenu = "medium";
const sizeSubMenuFA = 'xl';

export const Routes = [
    {
        path: "/",
        name: "Datos Operador",
        icon: <StorageIcon fontSize={size} />,
        screen: <Redirect to="/mis-datos" />,
        submenu: [
            {
                path: "/mis-datos",
                name: "Mis datos",
                screen: Datos,
                icon: <PermIdentityIcon fontSize={sizeSubMenu} />,
            },
            {
                path: "/certificados-activos",
                name: "Certificados activos",
                screen: Activos,
                icon: <VerifiedUserIcon fontSize={sizeSubMenu} />,
            },
            {
                path: "/servicios-activos",
                name: "Servicios activos",
                screen: Servicios,
                icon: <CheckIcon fontSize={sizeSubMenu} />,
            }
        ]
    },
    {
        path: "/unidades-produccion",
        name: "Unidades de producción",
        screen: <Redirect to="/" />,
        icon: <DataUsageIcon fontSize={size} />,
        endpoint: OPERATING,
        dynamicSubMenu: true, 
        submenu: [
            {
                path: "/parcelas",
                name: "Parcelas",
                screen: ExplotacionParcelas,
                icon: <EcoIcon fontSize={sizeSubMenu} />,
                dataKey: 'crops'
            },
            {
                path: "/ganado",
                name: "Ganado",
                screen: ExplotacionGanado,
                icon: <FontAwesomeIcon icon={faCow} size={sizeSubMenuFA} />,
                dataKey: 'beasts',
            },
            {
                path: "/productos",
                name: "Productos",
                screen: ExplotacionProductos,
                icon: <FontAwesomeIcon icon={faJar} size={sizeSubMenuFA} style={{ minWidth: 22 }} />,
                dataKey: 'products',
            }
        ]
    },
    {
        path: "/visitas-anunciadas",
        name: "Visitas anunciadas",
        screen: Visitas,
        icon: <ScheduleIcon fontSize={size} />
    },
 /*   {
        path: "/",
        name: "Facturas y abonos",
        screen: <Redirect to="/facturacion" />,
        icon: <ReceiptIcon fontSize={size} />,
        submenu: [
            {
                path: "/facturacion",
                name: "Facturación",
                screen: Facturacion,
                icon: <ReceiptIcon fontSize={sizeSubMenu} />,
            },
            {
                path: "/abonos",
                name: "Abonos",
                screen: Abonos,
                icon: <PaymentIcon fontSize={sizeSubMenu} />,
            },
        ]
    },*/
    {
        path: "/comunicaciones",
        name: "Comunicaciones",
        screen: Comunicaciones,
        icon: <MailIcon fontSize={size} />
    },
    {
        path: "/mis-solicitudes",
        name: "Mis solicitudes",
        screen: Aplicaciones,
        icon: <AppsIcon fontSize={size} />
    },
    {
        path: "/contacta",
        name: "Contacta",
        screen: Contacta,
        icon: <AlternateEmailIcon fontSize={size} />
    },   
    /*{
        path: "/",
        name: "Datos de usuarios",
        screen: <Redirect to="/mis-datos" />,
        icon: <PersonIcon fontSize={size} />,
        hideFromImpersonated: true,
        submenu: [
            {
                path: "/usuarios",
                name: "Usuarios",
                screen: Usuarios,
                icon: <GroupIcon fontSize={sizeSubMenu} />,
            },
            {
                path: "/autorizaciones",
                name: "Autorizaciones",
                screen: Delegaciones,
                icon: <VpnKeyIcon fontSize={sizeSubMenu} />,
            },
        ]
    }*/
]